import { AbstractControl, ValidatorFn } from '@angular/forms';

export const emailListPattern = (): ValidatorFn => {
    return (control: AbstractControl) => {
        if (!control.value) {
            return null;
        }

        const emailListPattern = /^([\w+-.%]+@[\w-.]+\.[A-Za-z]{2,4},?)+$/.test(control.value);

        if (!emailListPattern) {
            return {
                emailListPattern: true,
            };
        }

        return null;
    };
};
